import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { ISelectOption } from './selectOption.interface';
import { AiService } from '../api/agentStep.model';
import { getAiServiceLogoPath, getAiServiceDisplayName } from 'src/app/common/aiServiceUtils';
import { RSA_DEMO_AI_SERVICES } from './rsaDemoAiServices';

const issueSupportedServices: AiService[] = [
  AiService.chatGptEnterprise,
  AiService.copilotStudio,
  AiService.agentforce,
];

const rsaDemoIssueServices: AiService[] = [AiService.claudeCode, AiService.homegrown];

const toSelectOptions = (services: AiService[]): ISelectOption[] =>
  services
    .map((service) => ({
      id: `${FilterTypesEnum.AiService}-${service}`,
      value: service,
      displayName: getAiServiceDisplayName(service),
      filterType: FilterTypesEnum.AiService,
      categoryName: FilterTypesEnum.AiService.toString(),
      iconPath: getAiServiceLogoPath(service),
    }))
    .sort((a, b) => a.displayName.localeCompare(b.displayName));

const toSelectOptionsForPlaybooks = (services: AiService[]): ISelectOption[] =>
  services
    .map((service) => ({
      id: service,
      value: service,
      displayName: getAiServiceDisplayName(service),
      iconPath: getAiServiceLogoPath(service),
    }))
    .sort((a, b) => a.displayName.localeCompare(b.displayName));

export const IssueAiServiceSelectOptions: ISelectOption[] = toSelectOptions(issueSupportedServices);

export const IssueAiServiceSelectOptionsWithRsaDemo: ISelectOption[] = toSelectOptions([
  ...issueSupportedServices,
  ...rsaDemoIssueServices,
]);

export const IssueAiServiceSelectOptionsForPlaybooks: ISelectOption[] =
  toSelectOptionsForPlaybooks(issueSupportedServices);

export const RSA_DEMO_ISSUE_AI_SERVICES: Set<string> = new Set(RSA_DEMO_AI_SERVICES);
